import { useTranslation } from 'react-i18next';

import { Menu } from '@headlessui/react';
import { BellAlertIcon, BellSlashIcon } from '@heroicons/react/24/solid';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import { useEnablePushNotification } from '~/components/PWA/useEnablePushNotification';
import Typography from '~/components/Typography';
import { useDisplayMode } from '~/hooks/useDisplayMode';
import useIsLoggedIn from '~/hooks/useIsLoggedIn';

const EnablePushNotification = () => {
  const { webTheme: theme } = useWebThemeContext();
  const isLoggedIn = useIsLoggedIn();
  const { isSubscribed, onEnable } = useEnablePushNotification();
  const displayMode = useDisplayMode();
  const { t } = useTranslation();

  const label = isSubscribed ? t('nav.push.disable.label') : t('nav.push.enable.label');
  const Icon = isSubscribed ? BellSlashIcon : BellAlertIcon;
  // only allow push notifications in standalone/PWA mode
  if (displayMode !== 'standalone') return null;

  return (
    <Menu.Item>
      <div
        className="flex cursor-pointer items-center space-x-2 px-6 py-3"
        onClick={onEnable}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onEnable();
          }
        }}
      >
        <div
          style={{
            color: isLoggedIn ? theme?.navbar_text_color : '#a1a1aa',
          }}
        >
          <Icon className="h-4 w-4" />
        </div>
        <Typography
          as="span"
          className=""
          color={isLoggedIn ? theme?.navbar_text_color : '#a1a1aa'}
          weight="medium"
          fontFamilyv2={theme.navbar_font_family}
          size="sm"
        >
          {label}
        </Typography>
      </div>
    </Menu.Item>
  );
};

export default EnablePushNotification;
